import type { SpriteDef } from './types';
import { SYMBOL_SPRITES_A } from './symbols';
import { SYMBOL_SPRITES_B } from './symbols_classic';
import { SYMBOL_SPRITES_C } from './symbols_awake';
import { SYMBOL_SPRITES_D } from './symbols_rot';
import { SYMBOL_SPRITES_E } from './symbols_more';
import { CHARM_SPRITES } from './charms';
import { CHARM_SPRITES_R } from './charms_rare';
import { CHARM_SPRITES_U } from './charms_uncommon';
import { UI_SPRITES } from './ui';
import { FACE_SPRITES } from './face';
import { ITEM_SPRITES } from './items';
import { RELIC_SPRITES } from './relics';
import { PORTRAIT_SPRITES } from './portraits';
import { TITLE_SPRITES } from './title';
import { WEB_ICON_SPRITES } from './webicons';

export const ALL_SPRITES: SpriteDef[] = [
  ...SYMBOL_SPRITES_A,
  ...SYMBOL_SPRITES_B,
  ...SYMBOL_SPRITES_C,
  ...SYMBOL_SPRITES_D,
  ...SYMBOL_SPRITES_E,
  ...CHARM_SPRITES,
  ...CHARM_SPRITES_U,
  ...CHARM_SPRITES_R,
  ...UI_SPRITES,
  ...FACE_SPRITES,
  ...ITEM_SPRITES,
  ...RELIC_SPRITES,
  ...PORTRAIT_SPRITES,
  ...TITLE_SPRITES,
  ...WEB_ICON_SPRITES,
];

export const SPRITES_BY_ID: ReadonlyMap<string, SpriteDef> = new Map(ALL_SPRITES.map((s) => [s.id, s]));

export function getSprite(id: string): SpriteDef {
  const s = SPRITES_BY_ID.get(id);
  if (!s) throw new Error(`unknown sprite ${id}`);
  return s;
}

export function hasSprite(id: string): boolean {
  return SPRITES_BY_ID.has(id);
}
